// FV テキスト調整（PC=2改行 / SP=4行 化）
document.addEventListener('DOMContentLoaded', () => {
  const sel = '.banner__heading.inline-richtext.h1 strong';
  const mql = window.matchMedia('(max-width: 749px)');

  // PC用：1) 全角/半角「！」の直後, 2)「学びの扉ー」の直後で改行
  function toDesktop(html) {
    let t = html;
    t = t.replace(/！[ 　]*/, '！<br>').replace(/![ \u3000]*/, '!<br>');
    t = t.replace(/(学びの扉[ー—\-]?)/, '$1<br>');
    return t.replace(/(?:<br>\s*){2,}/g, '<br>');
  }

  // SP用：上記に加えて 3)「教科書から広がる」の直後で改行（なければ「あなたの」の前に改行）
  function toMobile(html) {
    let t = toDesktop(html); // まずPC版の2改行を適用
    const before = t;
    t = t.replace(/(教科書から広がる)/, '$1<br>');
    if (t === before) {
      // フォールバック（該当語が無い場合）
      t = t.replace(/([^>])あなたの/, '$1<br>あなたの');
    }
    return t.replace(/(?:<br>\s*){2,}/g, '<br>');
  }

  const nodes = Array.from(document.querySelectorAll(sel));

  // 元テキスト保存（何度走っても二重改行にならないように）
  nodes.forEach(el => {
    if (!el.dataset.originalText) {
      el.dataset.originalText = (el.textContent || '').trim();
    }
  });

  function apply() {
    nodes.forEach(el => {
      const base = el.dataset.originalText || (el.textContent || '').trim();
      el.innerHTML = mql.matches ? toMobile(base) : toDesktop(base);
    });
  }

  apply();
  // 画面幅が変わった時にも追従
  if (mql.addEventListener) mql.addEventListener('change', apply);
  else if (mql.addListener) mql.addListener(apply);
});

